module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/sorority-logos/s-logo-02-e57032bfd57cb532d4288137c5f77466.svg";